require('../../../../core/js/jquery/jquery')
require('../../../../core/js/jquery/jquery.ui.min')

// import {getCLS, getFID, getLCP} from 'web-vitals';
//
// getCLS(console.log);
// getFID(console.log);
// getLCP(console.log);